import BaseAccordion from 'components/Accordions/BaseAccordion';
import TimePeriodCard from 'features/Weather/components/TimePeriodCard/TimePeriodCard';
import { FaPlane } from 'react-icons/fa6';
import { formatDateTime } from 'utils/dates/date.utils';
import { airportDelayDetails } from '../../config/airportDelays.config';
import { getAirportDelayDays } from '../../utils/airportDelays.utils';

/**
 * Groups one airport's forecasts into dates, with a card for each time of day.
 * BaseAccordion handles opening and closing; TimePeriodCard provides the shared card styling.
 */
const AirportDelayAccordion = ({ report }) => {
  const days = getAirportDelayDays(report.segments);

  return (
    <BaseAccordion
      headingLevel="h3"
      header={
        <span className="fw-semibold text-break">{report.location || 'Unnamed airport'}</span>
      }
    >
      {!days.length && <p className="m-0">No forecast periods are available for this airport.</p>}
      <div className="d-flex flex-column gap-4">
        {days.map(({ key, date, segments }) => (
          <section key={key}>
            <h4 className="fs-6 fw-semibold border-bottom pb-2 mb-3">
              {formatDateTime(date, 'long', 'Date unavailable', true)}
            </h4>
            <div className="weather-time-period-grid d-grid gap-3">
              {segments.map((segment, index) => (
                <TimePeriodCard
                  key={`${segment.iso8601}-${index}`}
                  data={segment}
                  title={segment.day_segment || 'Time unavailable'}
                  headingLevel="h5"
                  subtitleIcon={<FaPlane size={64} />}
                  // Leave out missing reasons while keeping the forecast status visible.
                  details={airportDelayDetails.filter(
                    (detail) => detail.getValue(segment) !== null,
                  )}
                />
              ))}
            </div>
          </section>
        ))}
      </div>
    </BaseAccordion>
  );
};

export default AirportDelayAccordion;
